/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Nutritionist from './nutritionist';
import NutritionistDetail from './nutritionist-detail';
import NutritionistUpdate from './nutritionist-update';
import NutritionistDeleteDialog from './nutritionist-delete-dialog';

const NutritionistRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Nutritionist />} />
    <Route path="new" element={<NutritionistUpdate />} />
    <Route path=":id">
      <Route index element={<NutritionistDetail />} />
      <Route path="edit" element={<NutritionistUpdate />} />
      <Route path="delete" element={<NutritionistDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default NutritionistRoutes;
